import { Component, OnInit } from '@angular/core';
import { Router, RouterEvent } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { CVCService } from 'src/app/services/cvc.service';
import { UIService } from 'src/app/services/ui.service';
import { InfoPage } from '../info/info.page';
import { UsuarioPage } from '../usuario/usuario.page';

@Component({
  selector: 'app-navmenu',
  templateUrl: './navmenu.component.html',
  styleUrls: ['./navmenu.component.scss'],
})
export class NavmenuComponent implements OnInit {

  activePath = '';
  modo = null;

  pages = [

    {
      name: 'Inicio',
      path: '',
      acao: 'menu',
      icon: 'home-outline'
    },
    {
      name: 'Meus Dados',
      path: '',
      acao: 'perfil',
      icon: 'person-outline'
    },
    {
      name: 'Informações',
      path: '',
      acao: 'info',
      icon: 'information-circle-outline'
    },
    {
      name: 'Sair',
      path: '',
      acao: 'logout',
      icon: 'exit-outline'
    }
  ]


  constructor(private cvc: CVCService,
    private router: Router,
    public ui: UIService,
    private modalController: ModalController) {
    this.router.events.subscribe((event: RouterEvent) => {
      this.activePath = event.url;
    });
  }


  ngOnInit() {
    this.ui.getAppModo().then(result => { this.modo = result.value; });
  }

  acao(acao) {
    if (acao === 'menu') {
      this.router.navigateByUrl('/menu');
    }
    if (acao === 'logout') {
      this.cvc.logout();
      this.router.navigateByUrl('/login');
    }
    if (acao === 'perfil') {
      this.perfil();
    }
    if (acao === 'info') {
      this.info();
    }
  }


  async perfil() {
    const modal = await this.modalController.create({
      component: UsuarioPage,
      componentProps: {
        edit: true
      }
    });

    modal.onDidDismiss().then((resp) => {
      if (resp.data === true) {
        // this.updateview();
      }
    });

    modal.present();

  }


  async info() {
    const modal = await this.modalController.create({
      component: InfoPage,
      componentProps: {
        edit: true
      }
    });

    modal.onDidDismiss().then((resp) => {
      if (resp.data === true) {
        // this.updateview();
      }
    });

    modal.present();

  }

}
